import ContactCardLexique from 'locales/types/containers/propositionPage/contactCard';

export const contactCardLexique: ContactCardLexique = {
    title: `Your contact`,
    subText: `If you need any help, please feel free to contact your project assistant:`,
};

export default contactCardLexique;
